import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
    /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tSites\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_7 = { class: "form-contents" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "clearfix" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_11 = { class: "input-group top_search" };
const _hoisted_12 = { class: "input-group-btn" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_16 = { class: "checkbox-wrapper" };
const _hoisted_17 = { class: "col-xs-12 col-sm-12" };
const _hoisted_18 = { class: "card bg-white data-grid detached" };
const _hoisted_19 = { class: "table table-hover bottom0 pw100" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* HOISTED */);
const _hoisted_21 = { class: "hidden-sm" };
const _hoisted_22 = { class: "hidden-sm" };
const _hoisted_23 = { class: "hidden-sm" };
const _hoisted_24 = { class: "text-center hidden-sm" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* HOISTED */);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_28 = { class: "clearfix visible-sm" };
const _hoisted_29 = { class: "clearfix" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-map-marker" }, null, -1 /* HOISTED */);
const _hoisted_31 = { class: "hidden-sm" };
const _hoisted_32 = { class: "hidden-sm" };
const _hoisted_33 = { class: "hidden-sm" };
const _hoisted_34 = { key: 0 };
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "5"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_36 = [
    _hoisted_35
];
const _hoisted_37 = { class: "data-grid-footer clearfix detached pw100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_router_link, { to: { name: 'site' } }, {
                        default: _withCtx(() => [
                            _createVNode(_component_b_button, { variant: "primary" }, {
                                default: _withCtx(() => [
                                    _hoisted_6,
                                    _createTextVNode(" Add Site\r\n\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_12, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, _hoisted_14)
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_b_form_checkbox, {
                                id: "includeArchived",
                                modelValue: _ctx.query.includeDeleted,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.includeDeleted) = $event)),
                                size: "lg"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue"])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("table", _hoisted_19, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _hoisted_20,
                                    _createTextVNode(),
                                    _createElementVNode("th", null, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'SiteName', title: 'Site' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("th", _hoisted_21, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'Address.StreetAddress1', title: 'Street' }
                                        }, null, 8 /* PROPS */, ["sorter", "column"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("th", _hoisted_22, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'Address.StreetAddress3', title: 'City' }
                                        }, null, 8 /* PROPS */, ["sorter", "column"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("th", _hoisted_23, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'Address.Country.CountryName', title: 'Country' }
                                        }, null, 8 /* PROPS */, ["sorter", "column"])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        class: _normalizeClass({ 'deleted': item.whenDeleted })
                                    }, [
                                        _createElementVNode("td", _hoisted_24, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.edit(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_25,
                                                                    _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _createTextVNode(),
                                                            _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.archive(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_26,
                                                                    _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                                [_vShow, !item.whenDeleted]
                                                            ]),
                                                            _createTextVNode(),
                                                            _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.restore(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_27,
                                                                    _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                                [_vShow, item.whenDeleted]
                                                            ])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", null, [
                                            _createVNode(_component_router_link, {
                                                to: { name: 'site', params: { 'id': item.siteId } },
                                                class: "blue hidden-sm"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.siteName), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_28, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'site', params: { 'id': item.siteId } },
                                                    class: "lead"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.siteName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_29, [
                                                    _withDirectives(_createElementVNode("div", null, [
                                                        _hoisted_30,
                                                        _createTextVNode(" " + _toDisplayString(_ctx.getCombinedAddress(item)), 1 /* TEXT */)
                                                    ], 512 /* NEED_PATCH */), [
                                                        [_vShow, item.address]
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_31, _toDisplayString(item.address ? item.address.streetAddress1 : ''), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_32, _toDisplayString(item.address ? item.address.streetAddress3 : ''), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_33, _toDisplayString(item.address ? item.address.countryName : ''), 1 /* TEXT */)
                                    ], 2 /* CLASS */));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_34, _hoisted_36))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_b_pagination, {
                            class: "float-end",
                            modelValue: _ctx.query.pageNo,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.pageNo) = $event)),
                            "per-page": _ctx.query.pageSize,
                            "total-rows": _ctx.data.recordCount,
                            "hide-ellipsis": true,
                            disabled: _ctx.working
                        }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ])
    ]));
}
